export enum VehicleTypes {
  CAR = 'car',
  TRUCK = 'truck',
  BUS = 'bus',
  MOTORCYCLE = 'motorcycle'
}

export enum DetectionVehicleTypes {
  CAR = 1,
  TRUCK = 2,
  BUS = 3,
  MOTORCYCLE = 4,
}
